import Link from "next/link";
import { portalRoutes } from "@nju/routes";
import { A, ButtonsWrapper, Text } from "@nju/ui";

export function NoFundsButtons() {
  return (
    <ButtonsWrapper>
      <Link
        href={portalRoutes.mojeKonto.index.get({ mode: "mobile" })}
        passHref={true}
      >
        <A
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "s",
            "@fromDesktop": "m",
          }}
          variant="secondary"
        >
          anuluj
        </A>
      </Link>
      <div className="flex flex-col-reverse from-tablet:flex-row">
        <Link
          href={portalRoutes.mojeKonto.platnosci.index.get()}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "s",
              "@fromDesktop": "m",
            }}
            variant="simple"
          >
            <Text withUnderline={true}>zmień metodę płatności</Text>
          </A>
        </Link>
        <Link
          href={portalRoutes.mojeKonto.platnosci.dodajSrodki.get()}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "s",
              "@fromDesktop": "m",
            }}
            variant="primary"
          >
            wpłać środki
          </A>
        </Link>
      </div>
    </ButtonsWrapper>
  );
}
